import {Footer, Signup} from "../../components";
import React from "react";

export default function SignupPage() {
    return (
        <div>
            <Signup/>
            <Footer/>
        </div>
    )
}
